(() => {
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  const MAX_TRIES = 40;
  const TRY_EVERY_MS = 150;

  function getFlickityInstance(el) {
    const Flickity = window.theme?.Flickity || window.Flickity;
    if (!Flickity || typeof Flickity.data !== 'function') return null;
    return Flickity.data(el);
  }

  function destroyThumbFlickity(thumbs) {
    const flkty = getFlickityInstance(thumbs);
    if (flkty) flkty.destroy();

    // Unwrap si existieran wrappers
    const viewport = thumbs.querySelector('.flickity-viewport');
    const slider = thumbs.querySelector('.flickity-slider');
    if (viewport && slider) {
      while (slider.firstChild) thumbs.appendChild(slider.firstChild);
      viewport.remove();
    }

    thumbs.classList.remove('flickity-enabled', 'is-draggable');
    thumbs.removeAttribute('tabindex');
  }

  function syncThumbHeightToMain(thumbs, mainSlider) {
    const mainViewport = mainSlider.querySelector('.flickity-viewport') || mainSlider;

    const apply = () => {
      const h = mainViewport.getBoundingClientRect().height;
      if (h > 0) thumbs.style.maxHeight = `${Math.round(h)}px`;
    };

    apply();

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(apply);
      ro.observe(mainViewport);
    } else {
      window.addEventListener('resize', apply);
      setTimeout(apply, 300);
    }
  }

  function getThumbItems(thumbs) {
    // En tu theme los thumbs son .product-single__thumbnail
    const items = Array.from(
      thumbs.querySelectorAll('.product-single__thumbnail, [data-media-thumb]')
    );
    return items;
  }

  function markSelectedThumb(thumbItems, index) {
    thumbItems.forEach((el, i) => {
      el.classList.toggle('is-selected', i === index);
      el.classList.toggle('is-nav-selected', i === index);
      if (i === index) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });
  }

  function bindThumbClicks(thumbs, mainFlickity) {
    if (!thumbs || !mainFlickity) return;

    const thumbItems = getThumbItems(thumbs);
    if (!thumbItems.length) return;

    // Evita doble binding si Shopify recarga sección
    if (thumbs.dataset.leftThumbsBound === '1') return;
    thumbs.dataset.leftThumbsBound = '1';

    // Click / keyboard -> mover carrusel principal
    thumbItems.forEach((thumbEl, idx) => {
      // Hace el thumb "clickeable" aunque sea un div
      thumbEl.setAttribute('role', 'button');
      thumbEl.setAttribute('tabindex', '0');

      const handler = (e) => {
        // Si adentro hay <a>, evitamos que navegue
        if (e.type === 'click') e.preventDefault?.();
        mainFlickity.select(idx, true, true);
        markSelectedThumb(thumbItems, idx);
      };

      thumbEl.addEventListener('click', handler);

      thumbEl.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handler(e);
        }
      });
    });

    // Cuando cambia el slide principal (flechas/swipe), actualiza el thumb seleccionado
    const onSelect = () => {
      const selectedIndex = mainFlickity.selectedIndex || 0;
      markSelectedThumb(thumbItems, selectedIndex);
    };

    mainFlickity.on('select', onSelect);
    onSelect(); // inicial
  }

  function init() {
    // ✅ En móvil NO hacemos nada: se queda el comportamiento original del theme
    if (!DESKTOP_MQ.matches) return;

    const gallery = document.querySelector('.product-gallery--left-thumbs');
    if (!gallery) return;

    const thumbs = gallery.querySelector('#ProductThumbs');
    const mainSlider = gallery.querySelector('.product-gallery__media-slider');
    if (!thumbs || !mainSlider) return;

    let tries = 0;
    const timer = setInterval(() => {
      tries++;

      const mainFlickity = getFlickityInstance(mainSlider);
      const thumbsFlickity = getFlickityInstance(thumbs);

      const mainReady =
        !!mainFlickity ||
        mainSlider.classList.contains('flickity-enabled') ||
        mainSlider.querySelector('.flickity-viewport');

      // Si el main aún no está listo, seguimos esperando
      if (!mainReady && tries < MAX_TRIES) return;

      // Si Flickity se aplicó a thumbs, lo destruimos SOLO en desktop
      if (thumbsFlickity || thumbs.classList.contains('flickity-enabled') || thumbs.querySelector('.flickity-viewport')) {
        destroyThumbFlickity(thumbs);
      }

      // Ajusta altura del contenedor thumbs al alto del main
      syncThumbHeightToMain(thumbs, mainSlider);

      // ✅ Reconecta clicks de thumbs -> main slider
      const flkty = getFlickityInstance(mainSlider);
      if (flkty) {
        bindThumbClicks(thumbs, flkty);
      }

      clearInterval(timer);
    }, TRY_EVERY_MS);
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);

  DESKTOP_MQ.addEventListener?.('change', () => init());
})();